import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { assignEmpThunk } from "../../asyncThunks/overView/overview";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const assignEmp = createSlice({
    name: "assignEmp",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(assignEmpThunk.pending, (state, action) => {
            state.error = null;
            state.data = null;
            state.loading = true;
        });
        builder.addCase(assignEmpThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(assignEmpThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export default assignEmp.reducer;
